import React, { useState, useEffect } from "react";
import { selectTransUnits, selectCurrentStep, selectLanguages, selectMTmodel, selectAnimationClass } from "../reducers/selectors";
import { useDispatch, connect, useSelector } from "react-redux";
import { updateSourceLanguageId, updateTargetLanguageId, updateSourceText, generateUpdateSourceTextAction } from "../reducers/translateReducer";
import { resetDetectedLanguage } from "../reducers/languageReducer";
import { updateStepperState, setAnimationClass } from "../reducers/stateManagmentReducer";
import Select from "react-select";
import { Form, Card, Alert, Button, Dropdown } from "react-bootstrap";
import { createStructuredSelector } from "reselect";
import {fetchLanguages, getMachineTranslation, getTranslation} from "../Connector/Connector";
import { ReactComponent as LangDetec } from "../assets/images/langPicker/lan-detected-icon.svg";

const LanguagePicker = (props) => {
  //REDUX
  const dispatch = useDispatch();

  //STATE
  const [resetLanguageSelector, setResetLanguageSelector] = useState({
    SystemName: "",
  });
  useEffect(() => {
    window.scrollTo(0, 0);
    if(props.languages.languages.length === 0){
      dispatch(fetchLanguages())
    }

  }, []);

  //HADNLERS

  const nextClickHandler = () => {
    props.setAnimation("animate__fadeOutLeft");
    dispatch(getTranslation(props.modelMT));
    setTimeout(() => {
      props.updateStepperState({ activeStep: 2 });
    }, 1000);
    //props.setAnimation("animate__fadeInLeft");
    //dispatch(getMachineTranslation(props.modelMT));
   
  };

  const sourceLangHandler = (e) => {
    //dispatch(updateSourceLangId(e.Id));
    props.onSourceLangSelect(e.Id);
    setResetLanguageSelector("One");
  };
  const tragetLangHandler = (e) => {
    if (props.languages.isLanguageDetected) {
      //dispatch(updateSourceLangId(props.languages.languageDetectedId));
      props.onSourceLangSelect({langId:props.languages.languageDetectedId, langCode: props.languages.languageSourceCode.substring(0, 2)});
    }
    setResetLanguageSelector({ systemName: e.systemName });
    props.updateSourceText({targetId: e.id,  langCode: e.langCode.substring(0, 2)});
  };

  const printDetectetLanguageName = () => {
    let lang = props.languages.languages.find((x) => x.langCode.substring(0,2) === props.languages.languageSourceCode.substring(0, 2));
    if (lang === undefined) {
      return "unknown";
    } else {
      return lang.nativeName;
    }
  };

  return (
    <div className={`card mt-5 animate__animated ${props.animation} `}>
      <div className="row ps-4 pt-5">
        <div className="col">
          <div className="lang-text pt-2">
            <p>
              <span>Choose</span> languages
            </p>
          </div>
        </div>
      </div>
      <div className="lang-picker">
        <div className="row">
          <div className="picker-1 pb-4">
            <p>Translate from: </p>
            {/* {props.languages.isLanguageDetected && props.languages != "undefined" ? (
              <span>
                {printDetectetLanguageName(props.languages.languageDetectedId)} (auto-detected) &nbsp;
                <button className="btn btn-primary" onClick={() => props.resetDetectedLanguage()}>
                  Change
                </button>
              </span>
            ) : ( */}

            <Select
              size={30}
              // defaultInputValue={printDetectetLanguageName(props.languages.languageDetectedId)}
              //id="source"
              placeholder={printDetectetLanguageName()}
              className="source"
              options={props.languages.languages}
              getOptionLabel={(option) => option.systemName}
              onChange={sourceLangHandler}
            />
            {/* )} */}
          </div>
        </div>
        <div className="row">
          <div className="picker-2">
            <span>Translate into:</span>
            {props.languages != "undefined" ? (
              <Select
                options={props.languages.languages}
                getOptionLabel={(option) => option.systemName}
                onChange={tragetLangHandler}
                style={{ background: "black" }}
                // value={resetLanguageSelector}
              />
            ) : (
              <h5>Opps</h5>
            )}
          </div>
        </div>
        <div className="row text-center">
          <Button className="btn-footer mx-auto mt-5" disabled={!props.modelMT.isTrageLangSelected} onClick={() => nextClickHandler()}>
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    langId: (langId) => dispatch(langId(langId)),
    resetDetectedLanguage: () => dispatch(resetDetectedLanguage()),
    updateStepperState: (activeStep) => dispatch(updateStepperState(activeStep)),
    onSourceLangSelect: (id, langCode) => dispatch(updateSourceLanguageId(id, langCode)),
    onTargetLangSelect: (langCode) => dispatch(updateTargetLanguageId(langCode)),
    //updateSourceText: (textSegments) => dispatch(updateSourceText(textSegments)),
    updateSourceText: (targetId, langCode) => dispatch(generateUpdateSourceTextAction(targetId, langCode)),
    setAnimation: (animation) => dispatch(setAnimationClass(animation)),
    //segments: (data) => dispatch(reduceDiplayedSegments(data)),
  };
};
const mapStateToProps = createStructuredSelector({
  file: selectTransUnits,
  modelMT: selectMTmodel,
  languages: selectLanguages,
  animation: selectAnimationClass,
});
export default connect(mapStateToProps, mapDispatchToProps)(LanguagePicker);
